import React from "react"
import { Link } from "gatsby"

const Nav = ({ prefix }) => {
  const { href } =
    typeof window !== "undefined" ? window.location : { href: "" }

  const isBlog = href.includes("blog")
  const isTestimonials = href.includes("testimonials")
  const isAbout = href.includes("about")
  const isContact = href.includes("contact")

  return (
    <div className="flex w-full py-4">
      {prefix}
      <nav>
        <Link
          className={`uppercase ${isAbout ? "text-deeppink" : ""}`}
          to="/about"
        >
          About
        </Link>
        <Link
          className={`ml-4 uppercase ${isBlog ? "text-deeppink" : ""}`}
          to="/blog"
        >
          Blog
        </Link>
        <Link
          className={`ml-4 uppercase ${isTestimonials ? "text-deeppink" : ""} `}
          to="/testimonials"
        >
          Testimonials
        </Link>
        <Link
          className={`ml-4 uppercase ${isContact ? "text-deeppink" : ""}`}
          to="/contact"
        >
          Contact
        </Link>
      </nav>
    </div>
  )
}

export default Nav
